// Striscione partnership: loghi reali dove disponibili, wordmark tipografici altrove
const PARTNERS = [
  { name: "Silac", logo: "/assets/partners/silac.png?v=2" },
  { name: "Made in Taranto", logo: "/assets/partners/madeintaranto.png" },
  { name: "Imprenditori di Successo", logo: "/assets/partners/ids.png" },
  { name: "Saphìra Communication s.r.l.", logo: "/assets/partners/saphira.png" },
  { name: "Sinergica s.r.l.", logo: "/assets/partners/sinergica.png?v=2" },
  { name: "OverPress Media", logo: "/assets/partners/overpress.png" },
  { name: "Marketking", logo: "/assets/partners/marketking.png" },
  { name: "Vittorio Valentino Esposito" },
  { name: "Sponzami", logo: "/assets/partners/sponzami.png" },
  { name: "FlixBus", logo: "/assets/partners/flixbus.png" },
  { name: "PayPal", logo: "/assets/partners/paypal.svg" },
];

const PartnerItem = ({ p }) => (
  <span
    className="group flex shrink-0 items-center gap-3 px-10"
    data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
  >
    {p.logo ? (
      <img
        src={p.logo}
        alt={p.name}
        loading="lazy"
        className="h-9 w-auto max-w-[130px] object-contain opacity-60 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0"
      />
    ) : (
      <span className="whitespace-nowrap font-display text-lg font-bold tracking-tight text-neutral-400 transition-colors duration-500 group-hover:text-ink">
        {p.name}
      </span>
    )}
    {p.logo && (
      <span className="whitespace-nowrap font-mono text-[10px] tracking-wider text-neutral-400 transition-colors duration-500 group-hover:text-ink">
        {p.name}
      </span>
    )}
  </span>
);

export default function PartnersMarquee() {
  return (
    <section
      aria-label="Partner e collaborazioni"
      data-testid="partners-marquee"
      className="overflow-hidden border-b border-neutral-200 bg-paper py-10"
    >
      <p className="mb-8 text-center font-mono text-[10px] tracking-[0.3em] text-neutral-400">
        HO PROGETTATO PER LORO
      </p>
      <div className="animate-marquee flex w-max">
        <div className="flex shrink-0 items-center">
          {PARTNERS.map((p) => (
            <PartnerItem key={p.name} p={p} />
          ))}
        </div>
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {PARTNERS.map((p) => (
            <PartnerItem key={`${p.name}-dup`} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
